import React, { useState } from "react";
import "./Image.css";

const Image = ({ src, alt, ...props }) => {
  const [hasError, setHasError] = useState(false);

  const handleError = () => {
    setHasError(true);
  };

  if (hasError || !src) {
    return (
      <div
        className={`Image--Fallback ${props.className || ""}`}
        style={props.style}
      >
        Нет фото
      </div>
    );
  }

  return <img src={src} alt={alt} onError={handleError} {...props} />;
};

export default Image;
